import { useContext } from 'react';
import { DrawerContext } from 'providers/drawer-provider';
import SaveSearchFiltersGroupDrawer from './SaveSearchFiltersGroupDrawer';

export function DynamicDrawer(): JSX.Element | null {
  const { setActive, active, drawerProps } = useContext(DrawerContext);
  return (
    <SaveSearchFiltersGroupDrawer active={active} onClose={(): void => setActive(false)}>
      {drawerProps}
    </SaveSearchFiltersGroupDrawer>
  );
}
